// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '00590120a0ed77b432bb249408af013b7b5d4336';
export const BUILD_NUMBER = '234';
export const BUILD_TIMESTAMP = '2026-09-14T04:02:24.280Z';
